var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col"},[_c('OButton',{staticClass:"block focus:outline-none",class:{
      'added': _vm.added,
      'disabled': _vm.isDisabled
    },attrs:{"variant":_vm.variant,"disabled":_vm.isDisabled},on:{"click":_vm.onClick}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }